
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import {
//   Box,
//   Paper,
//   Typography,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Chip,
//   TablePagination,
//   CircularProgress,
// } from "@mui/material";
// import { BASE_URL } from "../../../services/configUrls";

// const statusColor = {
//   Pending: "warning",
//   Booked: "success",
//   Cancelled: "error",
//   Completed: "info",
// };

// const TrainerInterestsTable = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   useEffect(() => {
//     fetchInterests();
//   }, []);

//   const fetchInterests = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `${BASE_URL}/event/trainer-institute-interests`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//           },
//         }
//       );
//       setData(res.data || []);
//     } catch (err) {
//       console.error("Failed to fetch FDP interests", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (date) =>
//     new Date(date).toLocaleDateString("en-GB", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//     });

//   const getDateRange = (start, end) =>
//     `${formatDate(start)} – ${formatDate(end)}`;

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" py={6}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <>
//       {/* 🔹 Page Title */}
//       <Box mb={3} ml={2}>
//         <Typography variant="h5" fontWeight={700} mt={2}>
//           My FDP Interests
//         </Typography>
//         <Typography variant="body2" color="text.secondary">
//           Track your FDP requests, schedules, and current status
//         </Typography>
//       </Box>

//       {/* 🔹 Table */}
//       <Paper sx={{ borderRadius: 3, ml:2,mr:2,border: "1px solid #e5e7eb" }}>
//         <Table>
//           <TableHead>
//             <TableRow sx={{ backgroundColor: "#f8fafc" }}>
//               <TableCell sx={{ fontWeight: 600 }}>Domain</TableCell>
//               <TableCell sx={{ fontWeight: 600 }}>Institute</TableCell>
//               <TableCell sx={{ fontWeight: 600 }}>Date Range</TableCell>
//               <TableCell sx={{ fontWeight: 600 }}>Trainer</TableCell>
//               <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {data
//               .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//               .map((row) => (
//                 <TableRow key={row.interest_id} hover>
//                   <TableCell>{row.domain_name}</TableCell>

//                   <TableCell sx={{ maxWidth: 260 }}>
//                     <Typography noWrap>
//                       {row.institute_name}
//                     </Typography>
//                   </TableCell>

//                   <TableCell>
//                     {getDateRange(row.start_date, row.end_date)}
//                   </TableCell>

//                   <TableCell>
//                     <Typography fontWeight={500}>
//                       {row.trainer_name}
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       {row.trainer_email}
//                     </Typography>
//                   </TableCell>

//                   <TableCell>
//                     <Chip
//                       size="small"
//                       label={row.status}
//                       color={statusColor[row.status] || "default"}
//                     />
//                   </TableCell>
//                 </TableRow>
//               ))}

//             {data.length === 0 && (
//               <TableRow>
//                 <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
//                   <Typography color="text.secondary">
//                     No FDP interests found
//                   </Typography>
//                 </TableCell>
//               </TableRow>
//             )}
//           </TableBody>
//         </Table>

//         <TablePagination
//           component="div"
//           count={data.length}
//           page={page}
//           rowsPerPage={rowsPerPage}
//           onPageChange={(_, newPage) => setPage(newPage)}
//           onRowsPerPageChange={(e) => {
//             setRowsPerPage(parseInt(e.target.value, 10));
//             setPage(0);
//           }}
//           rowsPerPageOptions={[5, 10, 25]}
//         />
//       </Paper>
//     </>
//   );
// };

// export default TrainerInterestsTable;

import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  TablePagination,
  CircularProgress,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import { BASE_URL } from "../../../services/configUrls";

/* ---------------- CONSTANTS ---------------- */
const statusColor = {
  Pending: "warning",
  Booked: "success",
  Cancelled: "error",
  Completed: "info",
};

/* ✅ ALL MONTHS */
const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

const TrainerInterestsTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  /* 🔍 Filters */
  const [search, setSearch] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  useEffect(() => {
    fetchInterests();
  }, []);

  const fetchInterests = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${BASE_URL}/event/trainer-institute-interests`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      setData(res.data || []);
    } catch (err) {
      console.error("Failed to fetch FDP interests", err);
    } finally {
      setLoading(false);
    }
  };

  /* ✅ YEARS ONLY FROM API */
  const yearOptions = useMemo(() => {
    const years = new Set();
    data.forEach((row) => {
      if (row.start_date) {
        years.add(new Date(row.start_date).getFullYear());
      }
    });
    return Array.from(years).sort((a, b) => b - a);
  }, [data]);

  /* ---------------- FILTER LOGIC ---------------- */
  const filteredData = useMemo(() => {
    return data
      .filter((row) => {
        const q = search.toLowerCase();
        return (
          row.domain_name?.toLowerCase().includes(q) ||
          row.institute_name?.toLowerCase().includes(q)
        );
      })
      .filter((row) => {
        const d = new Date(row.start_date);
        if (month !== "" && d.getMonth() !== Number(month)) return false;
        if (year !== "" && d.getFullYear() !== Number(year)) return false;
        return true;
      });
  }, [data, search, month, year]);

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });

  const resetFilters = () => {
  setSearch("");
  setMonth("");
  setYear("");
  setPage(0);
};


  const getDateRange = (start, end) =>
    `${formatDate(start)} – ${formatDate(end)}`;

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={6}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      {/* 🔹 Page Title */}
      <Box mb={2} ml={2}>
        <Typography variant="h5" fontWeight={700} mt={2}>
          My FDP Interests
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Track your FDP requests, schedules, and current status
        </Typography>
      </Box>

      {/* 🔍 FILTER BAR */}
      <Paper sx={{ p: 2, mb: 2, mx: 2, borderRadius: 3 }}>
        <Box display="flex" gap={2} flexWrap="wrap">
          {/* ✅ SEARCH (Domain + Institute only) */}
          <TextField
            size="small"
            placeholder="Search Domain / Institute"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(0);
            }}
            InputProps={{ notched: false }}
            sx={{ minWidth: 260 }}
          />

          {/* ✅ MONTH */}
          <TextField
            select
            size="small"
            label="Month"
            value={month}
            onChange={(e) => {
              setMonth(e.target.value);
              setPage(0);
            }}
            sx={{ minWidth: 140 }}
          >
            <MenuItem value="">All</MenuItem>
            {MONTHS.map((m, i) => (
              <MenuItem key={m} value={i}>
                {m}
              </MenuItem>
            ))}
          </TextField>

          {/* ✅ YEAR */}
          <TextField
            select
            size="small"
            label="Year"
            value={year}
            onChange={(e) => {
              setYear(e.target.value);
              setPage(0);
            }}
            sx={{ minWidth: 120 }}
          >
            <MenuItem value="">All</MenuItem>
            {yearOptions.map((y) => (
              <MenuItem key={y} value={y}>
                {y}
              </MenuItem>
            ))}
          </TextField>
           <Box flexGrow={1} />

    <Button
      variant="outlined"
      color="secondary"
      onClick={resetFilters}
      disabled={!search && !month && !year}
      sx={{ height: 40 }}
    >
      Clear Filters
    </Button>
        </Box>
      </Paper>

      {/* 🔹 Table */}
      <Paper sx={{ borderRadius: 3, mx: 2, border: "1px solid #e5e7eb" }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f8fafc" }}>
              <TableCell sx={{ fontWeight: 600 }}>Domain</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Institute</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Date Range</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredData
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <TableRow key={row.interest_id} hover>
                  <TableCell>{row.domain_name}</TableCell>

                  <TableCell sx={{ maxWidth: 300 }}>
                    <Typography noWrap>
                      {row.institute_name}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    {getDateRange(row.start_date, row.end_date)}
                  </TableCell>

                  <TableCell>
                    <Chip
                      size="small"
                      label={row.status}
                      color={statusColor[row.status] || "default"}
                    />
                  </TableCell>
                </TableRow>
              ))}

            {filteredData.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                  <Typography color="text.secondary">
                    No records found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={filteredData.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={(_, newPage) => setPage(newPage)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    </>
  );
};

export default TrainerInterestsTable;
